import React, { useEffect, useState } from "react";
import usePortal from "../../../usePortal";
import iq_api_v2 from "../../../../../services/iqApiV2";
import "./ContactMapCardAddContact.css"; // Import the CSS file
import { useUser } from "../../../../../context/UserContext";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchContactCardRequest } from "../../../../../store/features/actions/opportunities/contactMapCardActions";
import { fetchOpportunitiesRequest } from "../../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest } from "../../../../../store/features/actions/opportunities/winOpportunitiesActions";
import Select from "react-select";

function ContactMapCardAddContact({ opportunityId, contact_list }) {

  const [openAddmem, setOpenAddMem] = useState(false);
  const [linkedinURL, setLinkedinURL] = useState(""); // State for LinkedIn URL input
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [error, setError] = useState(""); // State for error message
  const { user } = useUser();
  const { clientName, accountName } = useParams();
  const renderPortal = usePortal(openAddmem, () => setOpenAddMem(false));
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false)
  const [selectedContact, setSelectedContact] = useState(null);

  let contact_list_tmp = contact_list.map(contact => ({
    value: contact._id,
    label: contact.name,
    linkedin_url: contact.linkedin_url,
  }));
  contact_list_tmp.sort((a, b) => a.label.localeCompare(b.label));
  contact_list_tmp.unshift({ label: "--Select Contact--", value: "" });
  
  const contact_list_options = contact_list_tmp;

  useEffect(() => {
    setShowModal(false);
    setError(""); // Reset error on close
  }, []);

  const resetState = () => {
    setSelectedContact(null);
    setLinkedinURL("");
    setShowModal(false);
    setError("")
  };

  // LinkedIn URL validation regex
  const validateLinkedinURL = (url) => {
    const linkedInRegex =
      /^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/[a-zA-Z0-9-_]+\/?$/;
    return linkedInRegex.test(url.trim());
  };

  // Handle form submission
  const handleAddContact = async () => {

    var linkedin_url = ""

    if (!linkedinURL) {
      if(!selectedContact?.value){
        setError("Please select contact to add add");
        return
      }
    }else{
      linkedin_url = linkedinURL
    }

    if(!selectedContact?.value){
      if (!linkedinURL) {
        setError("Please enter a LinkedIn URL.");
        return;
      }
    }else{
      linkedin_url = selectedContact?.linkedin_url || ''
    }

    // Validate the LinkedIn URL
    if (!validateLinkedinURL(linkedin_url)) {
      setError("Please enter a valid LinkedIn URL.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        user_id: user?.id,
        linkedin_url: linkedin_url,
        opportunity_ids: [opportunityId],
        client: clientName,
        account: accountName,
        // Other data can be added as needed for the API call
      };

      const res = await iq_api_v2.post(
        "contact/add_contact_against_opportunity",
        payload
      );
      if (res.status == 200) {
        dispatch(fetchContactCardRequest({ opportunityId, userId: user?.id }));

        dispatch(
          fetchOpportunitiesRequest({
            clientName,
            accountName,
            userId: user.id,
            type: "spot",
          })
        );
        dispatch(
          fetchWinOpportunitiesRequest({
            clientName,
            accountName,
            userId: user.id,
            type: "win",
          })
        );
      }
      setSelectedContact("");
      setLinkedinURL(""); // Reset LinkedIn URL field after submission
      setShowModal(false); // Close portal after submission
    } catch (err) {
      // Handle API error
      if (err?.response?.status === 404) {
        setError("Contact already mapped for this opportunity!");
      } else {
        setError(
          `Error: ${err?.response?.data?.detail || "Something went wrong"}`
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="add-contact-btn-container">
        <button className="add-contact-btn new_add_cont_btn" onClick={() => setShowModal(true)}>
          Add Contact
        </button>
      </div>

      {/* {renderPortal?.(
        <div className="contact-modal-container form-control">
          <h5>Add Contact</h5>
          <input
            type="url"
            placeholder="Enter LinkedIn URL"
            value={linkedinURL}
            onChange={(e) => setLinkedinURL(e.target.value)}
            className="contact-input-field form-field"
          />
          {error && <p className="error-message">{error}</p>}
          <button
            onClick={handleAddContact}
            disabled={loading || linkedinURL.length < 10} // Disable button if URL is too short or loading
            className="contact-submit-btn"
          >
            {loading ? "Adding..." : "Submit"}
          </button>
        </div>
      )} */}

      {showModal && (
        <div className="reachout-modal" style={{zIndex: 900000}}>
          <div className="modal-content reachout_modal_content">
            

            {!linkedinURL && (
              <>
                {/* <select
                  className="modal-select aesthetic-dropdown mb-2"
                  onChange={(e) => {
                    const selected = contact_list?.find(
                      (item) => item._id === e.target.value
                    );
                    setSelectedContact(selected);
                    setLinkedinURL("");
                    setError("")
                  }}
                  value={selectedContact?._id || ""}
                >
                  <option value="">-- Select Contact --</option>
                  {[...contact_list].sort((a, b) => a.name.localeCompare(b.name))
                    .map((opp) => (
                      <option key={opp._id} value={opp._id}>
                        {opp.name}
                      </option>
                  ))}
                </select> */}
  
                <h4 className="modal_opp_top_head">
                  Select from existing contacts
                </h4>
                <Select
                  className="custom_agentform_control font14"
                  options={contact_list_options}
                  value={selectedContact?.value ? contact_list_options.find((opt) => opt.value === selectedContact?.value) : null}
                  isDisabled={loading}
                  onChange={(el) => {
                    const selected = contact_list_options?.find(
                      (item) => item.value === el.value && item.value != ""
                    );
                    setSelectedContact(selected);
                    setLinkedinURL("");
                    setError("")
                  }}
                  placeholder="Select Contact"
                />

                {error && <p className="error-message red font14">{error}</p>}

                {(!selectedContact) && <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                  <div style={{ flex: 1, height: '2px', backgroundColor: '#ccc' }}></div>
                  <span style={{ padding: '0 10px', color: '#666', 'fontWeight': '600' }}>OR</span>
                  <div style={{ flex: 1, height: '2px', backgroundColor: '#ccc' }}></div>
                </div>
                }

              </>
            )}

            {!selectedContact && (
              <>
              {!selectedContact && <h5 className="modal_opp_top_head mt-1">
                  Add new contact
                </h5>}
                <input
                  type="text"
                  className="modal-input mb-3"
                  placeholder="Contact Linkedin URL"
                  value={linkedinURL}
                  onChange={(e) => {
                    setLinkedinURL(e.target.value);
                    setSelectedContact(null);
                    setError("")
                  }}
                />
                {error && <p className="error-message red font14">{error}</p>}
              </>
            )}

            <div className="modal-actions">
              <button className="cancel_modal_btn" 
                onClick={resetState}
              >
                Cancel
              </button>
              <button
              className="genrate_modal_btn"
              disabled={((!selectedContact && !linkedinURL) || loading )}
                onClick={handleAddContact}
               >
                {loading ? "Adding..." : "Submit"}
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ContactMapCardAddContact;
